var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.$route.meta.pc)?_c('el-backtop'):_vm._e(),(_vm.$route.meta.pc)?_c('mzj_Header'):_vm._e(),(_vm.$route.meta.pc)?_c('mzj_Nav'):_vm._e(),_c('router-view'),(_vm.$route.meta.pc)?_c('mzj_Footer'):_vm._e(),(_vm.$route.meta.h5)?_c('h5_Footer'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }